import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type AnimeCharacter = {
  id: string;
  character_name: string;
  anime_name: string;
  gender: 'boy' | 'girl' | 'neutral';
  image_url: string;
  series?: string;
  total_ratings: number;
  average_rating: number;
  created_at: string;
  updated_at: string;
};

export type Rating = {
  id: string;
  user_id: string;
  character_id: string;
  rating: number;
  created_at: string;
  updated_at: string;
};

export type Profile = {
  id: string;
  username: string;
  avatar_character_id: string | null;
  avatar_url: string | null;
  avatar_zoom: {
    x: number;
    y: number;
    scale: number;
  };
  ratings_count: number;
  role: 'user' | 'admin';
  bio: string | null;
  show_highest_rated: boolean;
  created_at: string;
  updated_at: string;
};

export type Comment = {
  id: string;
  character_id: string;
  user_id: string;
  parent_id: string | null;
  content: string;
  created_at: string;
  updated_at: string;
  profiles?: Profile;
};

export type FavoriteCharacter = {
  id: string;
  user_id: string;
  character_id: string;
  position: number;
  created_at: string;
  anime_characters?: AnimeCharacter;
};

export type Notification = {
  id: string;
  user_id: string;
  type: string;
  content: string;
  related_user_id: string | null;
  related_character_id: string | null;
  read: boolean;
  created_at: string;
};
